import {fuzzyMatchRegex} from '@wandb/weave/common/util/fuzzyMatch';
import {TextField} from '@wandb/weave/components/Form/TextField';
import React, {useMemo, useState} from 'react';

import {useMediaSettingsDrawerContext} from '../../MediaSettingsDrawerContextProvider';
import {BoundingBoxesForMediaKey} from './BoundingBoxesForMediaKey';
import {ConfidenceSlider} from './ConfidenceSlider';

export const BoundingBoxes = () => {
  const {allBoxes, sliderRanges} = useMediaSettingsDrawerContext();
  const [boxSearchQuery, setBoxSearchQuery] = useState('');
  const boxQueryRegex = useMemo(
    () => fuzzyMatchRegex(boxSearchQuery),
    [boxSearchQuery]
  );

  return (
    <div className="flex flex-col">
      <div className="mb-8">
        <TextField
          dataTest="bounding-box-search-input"
          value={boxSearchQuery}
          onChange={setBoxSearchQuery}
          icon="search"
          placeholder="Search"
        />
      </div>
      {Object.keys(sliderRanges).map(key => (
        <ConfidenceSlider sliderKey={key} key={key} />
      ))}
      {Object.keys(allBoxes).map(mediaKey => (
        <BoundingBoxesForMediaKey
          mediaKey={mediaKey}
          key={mediaKey}
          boxQueryRegex={boxQueryRegex}
        />
      ))}
    </div>
  );
};
